import Client from './Clients/AxiosClient'
const resource = '/monitorConfig'

export default {
  get() {
    return Client.get(`${resource}`)
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
}
